export const CMSEndpoints = [
  {
    baseUrl: "seulah",
    name: "customer/lean/details",
    alias: "details",
    path: "cms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/screening/screening",
    alias: "screening",
    path: "cms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/digital-card/verification",
    alias: "verification",
    path: "cms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/lean/open-banking/customer",
    alias: "customer",
    path: "cms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/lean/open-banking/customer/status",
    alias: "leanCustomerStatus",
    path: "cms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/lean/open-banking/customer/salary",
    alias: "salary",
    path: "cms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/open-banking/account-statement/upload",
    alias: "upload",
    path: "cms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/terms/getTermsByLanguage",
    alias: "getTermsByLanguage",
    path: "cms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/callRequest",
    alias: "callRequest",
    path: "cms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/getIvrResponse",
    alias: "getIvrResponse",
    path: "cms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/selaApi/buy",
    alias: "buy",
    path: "cms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/emdha",
    alias: "emdha",
    path: "cms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/doc/agreement",
    alias: "agreement",
    path: "cms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/selaApi/transfer",
    alias: "transfer",
    path: "cms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/selaApi/transfer-ownerships",
    alias: "transfer-ownerships",
    path: "cms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/selaApi/redeem",
    alias: "redeem",
    path: "cms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/nafith/sanad-group",
    alias: "sanad-group",
    path: "cms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/lean/validateIban",
    alias: "validateIban",
    path: "cms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/lean/getIbanStatus",
    alias: "getIbanStatus",
    path: "cms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/gosi/income",
    alias: "income",
    path: "cms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/nafath",
    alias: "nafath",
    path: "cms",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/lean/duplicateIban",
    alias: "duplicateIbanLean",
    path: "cms",
    noToken: true,
    runAt: "onDemand",
  },
  
]

export const CMSEndpointsMapping = {
  Details: 'details',
  Screening: 'screening',
  Verification: 'verification',
  Customer: 'customer',
  BankingStatus: 'leanCustomerStatus',
  BankingSalary: 'salary',
  StatementUpload: 'upload',
  GetTermsByLanguage: 'getTermsByLanguage',
  CallRequest: 'callRequest',
  GetIvrResponse: 'getIvrResponse',
  Buy: 'buy',
  Emdha: 'emdha',
  Agreement: 'agreement',
  Transfer: 'transfer',
  TransferOwnerships: 'transfer-ownerships',
  Redeem: 'redeem',
  SanadGroup: 'sanad-group',
  ValidateIban: 'validateIban',
  GetIbanStatus: 'getIbanStatus',
  Income: 'income',
  Nafath: 'nafath',
  DuplicateIbanLean: 'duplicateIbanLean',
}